import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from 'react-router-dom';

interface CanonicalURLProps {
  baseUrl?: string;
}

export const CanonicalURL: React.FC<CanonicalURLProps> = ({ 
  baseUrl = 'https://wearecnxion.com' 
}) => {
  const location = useLocation();
  
  // Remove trailing slash and query parameters for canonical URL
  const path = location.pathname.replace(/\/$/, '');
  const canonicalUrl = `${baseUrl}${path}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};
